import { applyRuntimeThemeToDocument } from '@emporion/ui'
import { persistRuntimeTheme } from './cache'
import type { RuntimeTheme } from './types'

export const applyThemeToDocument = (theme: RuntimeTheme, options?: { persist?: boolean }) =>
  applyRuntimeThemeToDocument(theme, {
    persist: options?.persist,
    persistTheme: persistRuntimeTheme,
  })
